import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ClientInput } from "../inputs/ClientInput";
import { clientEntriesSelector } from "../../store/selectors/clientEntries";
import { getValue } from "../../lib/utils";
export const MirrorPreview = ({
  type,
  summary_entry,
  value,
  rowGuid,
  update,
  ...entry
}) => {
  const clientEntries = useSelector(clientEntriesSelector);
  const getMirroredValue = () => {
    if (summary_entry && summary_entry.guid) {
      const {
        guid: guidToMirror = ''
      } = summary_entry;
      if (rowGuid) {
        const {
          value = '',
          type
        } = clientEntries.find(p => p.parentGuid == guidToMirror && p.rowGuid == rowGuid) || {};
        return getValue(type, value, true);
      } else {
        const {
          value = '',
          type
        } = clientEntries.find(p => p.guid == guidToMirror) || {};
        return getValue(type, value, true);
      }
    }
    return '';
  };
  const memoizedMirrorCallback = useCallback(getMirroredValue(), [clientEntries]);
  useEffect(() => {
    update(memoizedMirrorCallback);
  }, [memoizedMirrorCallback]);
  const inputProps = {
    disabled: true,
    value: memoizedMirrorCallback,
    label: entry.label
  };
  return <ClientInput {...inputProps} />;
};